import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dfdc3e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-file-remark" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add-refund-title" }, "Proof description:", -1))

import {ref,watch} from 'vue'
import UploadFile from '@/components/upload/upload.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'afterFileRemark',
  props: {
    fileList:{
        type:Array
    },
    imgPathData:{
        type:Object
    },
    teaxAreaVal:{
        type:String
    },
    textAreaCon:{
        type:String,
        default:'Please provide clear image and description to facilitate your application. Image is only supported within 10MB. Video is only supported within 1 minute.'
    },
},
  emits: ['handleUpload','delFile','update:teaxAreaVal'],
  setup(__props, { emit }) {

const props = __props



let teaxVal = ref(props.teaxAreaVal)
watch(()=>teaxVal.value,(newVal:any)=>{
    emit('update:teaxAreaVal',newVal)
})
watch(()=>props.teaxAreaVal,(newVal:any)=>{
    teaxVal.value = newVal
})
const uploading = (data:any)=>{
    emit('handleUpload',data)
}
const DelFile = (file:any)=>{
    emit('delFile',file)

}

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(UploadFile, {
      fileList: __props.fileList,
      onUpload: uploading,
      onDelFile: DelFile,
      imgPathData: __props.imgPathData
    }, null, 8, ["fileList", "imgPathData"]),
    _createVNode(_component_van_field, {
      modelValue: _unref(teaxVal),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(teaxVal) ? (teaxVal).value = $event : teaxVal = $event)),
      "left-icon": _unref(teaxVal) && _unref(teaxVal).length > 0 ? ' ' : 'edit',
      type: "textarea",
      maxlength: "500",
      "show-word-limit": "",
      clearable: ""
    }, null, 8, ["modelValue", "left-icon"]),
    _createElementVNode("p", null, _toDisplayString(__props.textAreaCon), 1)
  ]))
}
}

})